import HotelMap from '@/components/googleMap/HotelMap'

export function init () {
  const root = document.getElementById('hotelMap')
  if (!root) return false

  const config = {
    latitude: root.dataset.latitude,
    longitude: root.dataset.longitude,
  }

  return new HotelMap({
    el: root,
    propsData: { config, preload: { type: 'mount' } },
  })
}


// WEBPACK FOOTER //
// ./src/modules/hotelMap.js